module.exports = __webpack_public_path__ + "static/media/popmoney.db3ad565.png";